import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { AuthService } from 'app/auth/auth.service';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { ReportserviceService } from 'app/reports/reportservice.service';
import { ExportService } from 'app/reports/services/export.service';

@Component({
  selector: 'app-advance-register',
  templateUrl: './advance-register.component.html',
  styleUrls: ['./advance-register.component.scss']
})
export class AdvanceRegisterComponent implements OnInit {
  toDaysDate: any;
  enddate: any;
  startdate: any;
  isValidDate: boolean;
  advanceRegList: any;
  public headerName = ['S.No', 'Receipt No.', 'UHID', 'Patient Name', 'Surgery Name', 'Pay Type', 'Amount', 'CreatedBy', 'Doctor'];
  UserDataArray: any;
  totalAmount: number;
  alltotalAmount: number;
  public advanceRegDataArray: any = [];

  constructor(
    public reportService: ReportserviceService, public authService: AuthService, public datePipe: DatePipe,
    public dashboardService: DashboardService, private exportdata: ExportService
  ) { }

  ngOnInit(): void {
    this.toDaysDate = this.authService.getServerDate;
    this.startdate = this.toDaysDate;
    this.enddate = this.toDaysDate;
    this.advanceRegister(this.authService.Loggeduser.branchid, this.startdate, this.enddate)
  }

  advanceRegister(branchId, fdate, tdate) {
    this.advanceRegDataArray = [];
    this.alltotalAmount = 0;
    this.reportService.getAdvanceRegister(branchId, fdate, tdate).subscribe(data => {
      let x = data;

      this.UserDataArray = data.reduce((s, { paymentDate }) => {
        if (!s.some(o => o.paymentDate == paymentDate)) {
          s.push({ paymentDate });
        }
        return s;
      }, []);
      let groupdata = x.reduce((r, { paymentDate }) => {
        if (!r.some(o => o.paymentDate == paymentDate)) {
          r.push({ paymentDate, UserItem: x.filter(v => v.paymentDate == paymentDate) });
        }
        return r;
      },
        []);
      console.log(groupdata)
      for (var i = 0; i < groupdata.length; i++) {
        this.totalAmount = 0;
        groupdata[i].UserItem.forEach(xt => {
          this.totalAmount = this.totalAmount + xt.amount;
        });
        this.alltotalAmount = this.alltotalAmount + this.totalAmount;
        this.advanceRegDataArray.push({
          "paymentdate": groupdata[i].paymentDate,
          "totalamount": this.totalAmount,
          "Useritem": groupdata[i].UserItem,
        });
      }
      this.advanceRegDataArray = this.advanceRegDataArray.sort((a, b) => a.paymentdate.localeCompare(b.paymentdate));
    })
  }

  getReportList() {
    let sdate = this.datePipe.transform(this.startdate, "yyyy-MM-dd");
    let edate = this.datePipe.transform(this.enddate, "yyyy-MM-dd");
    this.isValidDate = this.validateDates(sdate, edate);

    if (this.isValidDate != false) {
      this.advanceRegister(this.authService.Loggeduser.branchid, sdate, edate);
    } else {
      this.dashboardService.openSnackBar("End date should be greater than start date", "OK");
    }
  }

  validateDates(sDate: string, eDate: string) {
    this.isValidDate = true;
    if ((sDate == null || eDate == null)) {
      this.isValidDate = false;
    }

    if ((sDate != null && eDate != null) && (eDate) < (sDate)) {
      this.isValidDate = false;
    }
    return this.isValidDate;
  }

  exportexcel(): void {
    this.exportdata.open_loader_Dialogtwo();
    this.startdate = new Date();
    let element = document.getElementById('content');
    this.exportdata.Newexportxcel(element, 'Advance Register Date Wise');
  }


  public openPDF(): void {
    this.startdate = new Date();
    this.exportdata.open_loader_Dialogtwo();
    let DATA = document.getElementById('content');
    this.exportdata.downloadAsPDF(DATA, 'Advance Register Date Wise');
  }
  printPDF():void{
  this.exportdata.printpDFData();
  }
  printComponent(cmpName) {
    this.startdate = new Date();
    window.print();
  }
}
